import axios from 'axios';
import { apiNames, get, post, patch, put } from '@general/api/shared';

export const fetchEventByCode = async eventCode => {
    const response = await get(apiNames.TRANSACTION, `events/${eventCode}`);
    return response?.data?.data;
};

export const fetchEventFromEE = eventCode => {
    return axios.get('/api/event_details', {
        params: {
            meeting_code: eventCode,
            user: process.env.EE_API_USER,
            key: process.env.EE_API_KEY,
        },
    });
};

export const fetchEventCompanyRoster = ({ eventCode, companyId }) =>
    get(apiNames.TRANSACTION, `events/${eventCode}/roster?company_id=${companyId}`);

export const fetchRegistrantClass = ({ memberId, cartId, eventId }) => {
    return get(apiNames.TRANSACTION, `registrant-class/${memberId}?cart_id=${cartId}&event_id=${eventId}`);
};

export const fetchMemberEventSessions = ({ memberId, eventCode }) => {
    return get(apiNames.MEMBERSHIP, `members/${memberId}/events/${eventCode}/sessions`);
};
